import type { RouteObject } from 'react-router'

const lazy = (loader: () => Promise<{ default: React.ComponentType }>) => async () => {
  const m = await loader()
  return { Component: m.default }
}
const named =
  <K extends string>(loader: () => Promise<Record<K, React.ComponentType>>, key: K) =>
  async () => {
    const m = await loader()
    return { Component: m[key] }
  }

export const publicRoutes: RouteObject[] = [
  { index: true, lazy: lazy(() => import('./Home')) },
  { path: 'programs', lazy: named(() => import('./Programs'), 'ProgramsList') },
  { path: 'programs/:slug', lazy: named(() => import('./Programs'), 'ProgramDetail') },
  { path: 'events', lazy: named(() => import('./Events'), 'EventsList') },
  { path: 'events/submit', lazy: lazy(() => import('./SubmitEvent')) },
  { path: 'events/:slug', lazy: named(() => import('./Events'), 'EventDetail') },
  { path: 'riverfront', lazy: named(() => import('./Events'), 'Riverfront') },
  { path: 'schedule', lazy: lazy(() => import('./Schedule')) },
  { path: 'live', lazy: lazy(() => import('./Live')) },
  { path: 'checkin/v/:token', lazy: lazy(() => import('./Checkin')) },
  { path: 'resources', lazy: lazy(() => import('./Resources')) },
  { path: 'sponsors', lazy: lazy(() => import('./Sponsors')) },
  { path: 'about', lazy: named(() => import('./Landing'), 'About') },
  { path: 'vendors', lazy: named(() => import('./Landing'), 'VendorsLanding') },
  { path: 'parade', lazy: named(() => import('./Landing'), 'ParadeLanding') },
  { path: 'donate', lazy: lazy(() => import('./Donate')) },
  { path: 'donors', lazy: lazy(() => import('./Donors')) },
  { path: 'photos', lazy: lazy(() => import('./Photos')) },
  { path: 'photos/share', lazy: named(() => import('./Photos'), 'PhotoShare') },
  { path: 'love', lazy: named(() => import('./Love'), 'LoveIndex') },
  { path: 'love/:slug', lazy: named(() => import('./Love'), 'LoveWall') },
  { path: 'campaigns', lazy: named(() => import('./Campaigns'), 'CampaignsList') },
  { path: 'campaigns/:slug', lazy: named(() => import('./Campaigns'), 'CampaignDetail') },
  { path: 'squares/:slug', lazy: named(() => import('./Campaigns'), 'Squares') },
  { path: 'fundraise/:slug', lazy: lazy(() => import('./Fundraiser')) },
  { path: 'donate/thanks/:id', lazy: named(() => import('./Donate'), 'DonateThanks') },
  { path: 'shop', lazy: named(() => import('./Shop'), 'Shop') },
  { path: 'shop/cart', lazy: named(() => import('./Shop'), 'CartPage') },
  { path: 'shop/orders/:id', lazy: named(() => import('./Shop'), 'OrderStatus') },
  { path: 'shop/:slug', lazy: named(() => import('./Shop'), 'ProductPage') },
  { path: 'scholarships', lazy: named(() => import('./Scholarships'), 'ScholarshipsList') },
  { path: 'scholarships/:slug', lazy: named(() => import('./Scholarships'), 'ScholarshipDetail') },
  { path: 'volunteer', lazy: lazy(() => import('./Volunteer')) },
  { path: 'volunteer/interest', lazy: lazy(() => import('./VolunteerInterest')) },
  { path: 'board', lazy: lazy(() => import('./Board')) },
  { path: 'mutual-aid', lazy: lazy(() => import('./MutualAid')) },
  { path: 'map', lazy: named(() => import('./Map'), 'MapIndex') },
  { path: 'map/:slug', lazy: named(() => import('./Map'), 'PublicMap') },
  { path: 'apply/:slug', lazy: lazy(() => import('./Apply')) },
  { path: 'apply/:slug/:id', lazy: named(() => import('./Apply'), 'ApplicationRunner') },
  { path: 'apply/:slug/:id/done', lazy: named(() => import('./Apply'), 'ApplicationDone') },
  { path: 'sponsors/apply', lazy: lazy(() => import('./SponsorApply')) },
  { path: '2027', lazy: lazy(() => import('./Festival2027')) },
  {
    path: 'email-preferences/:token',
    lazy: named(() => import('./EmailPreferences'), 'EmailPreferences'),
  },
  { path: 'unsubscribe/:token', lazy: named(() => import('./EmailPreferences'), 'Unsubscribe') },
  {
    path: 'email-confirm/:token',
    lazy: named(() => import('./EmailPreferences'), 'ConfirmSubscription'),
  },
  { path: 'participate', lazy: lazy(() => import('./Participate')) },
  { path: '*', lazy: lazy(() => import('./NotFound')) },
]
